export enum RootRouteNames {
  ROOT = 'Root',
  MAIN = 'Main',
}
